import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { HomeownersComponent } from './homeowners/homeowners.component';
import { RealpropertyComponent } from './homeowners/realproperty/realproperty.component';
import { ChangeaddressComponent } from './homeowners/changeaddress/changeaddress.component';
import { ChangeInOwnershipComponent } from './homeowners/ChangeInOwnership/ChangeInOwnership.component';
import { NewConstructionComponent } from './homeowners/NewConstruction/NewConstruction.component';
import { NewhomeownersComponent } from './homeowners/newhomeowners/newhomeowners.component';
import { HomeownersexemptionComponent } from './homeowners/homeownersexemption/homeownersexemption.component';
import { ContestAssessedValueComponent } from './homeowners/ContestAssessedValue/ContestAssessedValue.component';
import { FormsComponent } from './forms/forms.component';
import { SupplementaltaxestimatorComponent } from './homeowners/supplementaltaxestimator/supplementaltaxestimator.component';
import { TransferringassessedvalueComponent } from './homeowners/transferringassessedvalue/transferringassessedvalue.component';
import { BusinessownersComponent } from './businessowners/businessowners.component';
import { MarineaircraftComponent } from './businessowners/marineaircraft/marineaircraft.component';
import { ManufacturedhomesComponent } from './businessowners/manufacturedhomes/manufacturedhomes.component';
import { BusinesspropertystatementComponent } from './businessowners/businesspropertystatement/businesspropertystatement.component';
import { SolarComponent } from './exclusions/solar/solar.component';
import { ExclusionsComponent } from './exclusions/exclusions.component';
import { BuildersComponent } from './exclusions/builders/builders.component';
import { TaxreliefComponent } from './taxrelief/taxrelief.component';
import { DisasterreliefComponent } from './taxrelief/disasterrelief/disasterrelief.component';
import { ExemptionsComponent } from './Exemptions/Exemptions.component';
import { DisabledveteransComponent } from './Exemptions/disabledveterans/disabledveterans.component';
import { TrendfactorsComponent } from './businessowners/trendfactors/trendfactors.component';
import { ContactComponent } from './contact/contact.component';
import { ContactTheAssessorComponent } from './contact/contactTheAssessor/contactTheAssessor.component';
import { DisabledtransferComponent } from './taxrelief/disabledtransfer/disabledtransfer.component';
import { DeclineinvalueComponent } from './taxrelief/declineinvalue/declineinvalue.component';
import { AduComponent } from './homeowners/adu/adu.component';
import { ContactSpeakerComponent } from './contact/contactSpeaker/contactSpeaker.component';
import { ContactCertificateComponent } from './contact/contactCertificate/contactCertificate.component';
import { OfficeLocationsComponent } from './contact/officeLocations/officeLocations.component';
import { Prop19Component } from './homeowners/prop19/prop19.component';
import { ChurchComponent } from './Exemptions/Church/Church.component';
import { ReligiousComponent } from './Exemptions/Religious/Religious.component';
import { ImportantdatesComponent } from './businessowners/Importantdates/Importantdates.component';
import { NewsInformationComponent } from './News-Information/News-Information.component';
import { WebinarsPresentationsComponent } from './News-Information/WebinarsPresentations/WebinarsPresentations.component';
import { BusinessStatementFilingComponent } from './businessowners/BusinessStatementFiling/BusinessStatementFiling.component';
import { RegisteredDomesticPartnersComponent } from './exclusions/RegisteredDomesticPartners/RegisteredDomesticPartners.component';
import { PropertySearchComponent } from './homeowners/propertySearch/propertySearch.component';
import { AboutUsComponent } from './About-us/About-us.component';
import { PropTaxSystemComponent } from './About-us/Prop-tax-system/Prop-tax-system.component';
import { NonProfitComponent } from './Exemptions/Non-Profit/Non-Profit.component';
import { NewslettersComponent } from './News-Information/Newsletters/Newsletters.component';
import { SearchComponent } from './search/search.component';
import { SearchV2Component } from './search-v2/search-v2.component';
import { DistrictOfficesComponent } from './contact/district-offices/district-offices.component';
import { WelfareComponent } from './Exemptions/Welfare/Welfare.component';
import { HospitalPropertyComponent } from './Exemptions/HospitalProperty/HospitalProperty.component';
import { MultispecialtyClinicsComponent } from './Exemptions/MultispecialtyClinics/MultispecialtyClinics.component';
import { HousingComponent } from './Exemptions/Housing/Housing.component';
import { AwardsComponent } from './News-Information/Awards/Awards.component';
import { AssessmentRollComponent } from './News-Information/assessmentRoll/assessmentRoll.component';
import { AnnualRollComponent } from './News-Information/annualRoll/annualRoll.component';
import { FeedbackComponent } from './contact/feedback/feedback.component';
import { PossessoryInterestComponent } from './PossessoryInterest/PossessoryInterest.component';
import { MeetTheAssessorComponent } from './About-us/meet-the-assessor/meet-the-assessor.component';
import { RealEstateToolkitComponent } from './RealEstateToolkit/RealEstateToolkit.component';
import { DisabledComponent } from './taxrelief/Disabled/Disabled.component';
import { DeathOfAnOwnerComponent } from './homeowners/DeathOfAnOwner/DeathOfAnOwner.component';
import { RealEstateFraudComponent } from './RealEstateFraud/RealEstateFraud.component';
import { FactorsPropValueComponent } from './RealEstateToolkit/Factors-Prop-Value/Factors-Prop-Value.component';
import { HowWeCalculateFMVComponent } from './RealEstateFraud/How-We-Calculate-FMV/How-We-Calculate-FMV.component';
import { WelcomeComponent } from './RealEstateToolkit/welcome/welcome.component';
import { Proposition13Component } from './RealEstateToolkit/Proposition13/Proposition13.component';
import { WillsTrustsComponent } from './RealEstateToolkit/WillsTrusts/WillsTrusts.component';
import { ApplyForHOXComponent } from './RealEstateToolkit/ApplyForHOX/ApplyForHOX.component';
import { RefinanceComponent } from './RealEstateToolkit/Refinance/Refinance.component';
import { WhenDoIGetReassessedComponent } from './RealEstateToolkit/WhenDoIGetReassessed/WhenDoIGetReassessed.component';
import { NewsroomComponent } from './News-Information/newsroom/newsroom.component';
import { VeteransComponent } from './Exemptions/Veterans/Veterans.component';
import { InterSpousalComponent } from './exclusions/InterSpousal/InterSpousal.component';
import { JointTenancyComponent } from './exclusions/JointTenancy/JointTenancy.component';
import { EventsComponent } from './RealEstateToolkit/Events/Events.component';
import { DataSalesComponent } from './DataSales/DataSales.component';
import { GISsalesComponent } from './DataSales/GISsales/GISsales.component';
import { DataSalesGeneralComponent } from './DataSales/DataSalesGeneral/DataSalesGeneral.component';
import { OnlinePDBComponent } from './DataSales/OnlinePDB/OnlinePDB.component';
import { PriceListComponent } from './DataSales/PriceList/PriceList.component';
import { MillsActComponent } from './taxrelief/MillsAct/MillsAct.component';
import { ChangeOwnershipRescissionComponent } from './taxrelief/ChangeOwnershipRescission/ChangeOwnershipRescission.component';
import { DirectoryComponent } from './contact/directory/directory.component';
import { BookingsComponent } from './contact/bookings/bookings.component';
import { BookingsFormComponent } from './contact/bookings/bookings-form/bookings-form.component';
import { BookingsDistrictComponent } from './contact/bookings/bookings-district/bookings-district.component';
import { PublicRecordsComponent } from './News-Information/publicRecords/publicRecords.component';
import { StatusComponent } from './forms/status/status.component';
import { MeetTheStaffComponent } from './About-us/meet-the-staff/meet-the-staff.component';
import { EnotificationComponent } from './News-Information/enotification/enotification.component';
import {FileOnlineV2Component} from './forms/file-online-v2/file-online-v2.component';
import {Ads820Component} from "./contact/ads820/ads820.component";
import { LanguageAccessServiceComponent } from './contact/languageAccessService/languageAccessService.component';
import { ChangelogComponent } from './ChangeLog/changelog.component';
import { DeathOfAnOwnerToolkitComponent } from './RealEstateToolkit/DeathOfAnOwner/DeathOfAnOwner.component';
import { CareerOpportunitiesComponent } from './News-Information/CareerOpportunities/CareerOpportunities.component';
import { EServicesAccountUpgradesComponent } from './News-Information/EServicesAccountUpgrades/EServicesAccountUpgrades.component';
import { Title } from '@angular/platform-browser';
import { WebsiteSupportComponent } from './contact/contactTheAssessor/websiteSupport/websiteSupport.component';
import {AdditionalSignerComponent} from './additional-signer/additional-signer.component';
import {SiteMapComponent} from './site-map/site-map.component';
import { AccessibilityStatementComponent } from './accessibility-statement/accessibility-statement.component';
import {ErrorComponent} from './error/error.component';
import {ENotificationRedirectComponent} from './_services/external-redirect/e-notification-redirect.component';
import {Efile} from './efile/efile';


const routes: Routes = [
  {path: '', component: HomeComponent},
  { path: 'sitemap', component: SiteMapComponent },
  {path: 'login', component: HomeComponent},
  {path: 'forms', component: FormsComponent},
  {path: 'efile/submit', component: FileOnlineV2Component},
  // {path: 'efile/submit2', component: Efile},
  {path: 'efile/status', component: StatusComponent},
  {path: 'accessibility-statement',component: AccessibilityStatementComponent},
  {path: 'contact/ads820', component: Ads820Component},
  {path: 'search', component: SearchComponent},
  {path: 'search-v2', component: SearchV2Component},
  { path: 'signature', component: AdditionalSignerComponent },
  { path: 'changelog', component: ChangelogComponent, data: {title: 'Changelog'} },

  {
    path: 'contact',
    component: ContactComponent,
    children: [
      {path: '', component: ContactTheAssessorComponent, data: {title: 'Contact The Assessor'}},
      {path: 'assessor', component: ContactTheAssessorComponent, data: {title: 'Contact The Assessor'}},
      {path: 'calamity-disaster', component: Ads820Component, data: {title: 'Disaster Relief (Calamity & Disaster)'}},
      {path: 'assessor/:id', component: ContactTheAssessorComponent, data: {title: 'Contact The Assessor'}},
      {path: 'requestspeaker', component: ContactSpeakerComponent, data: {title: 'Request Speaker'}},
      {path: 'requestcertificate', component: ContactCertificateComponent, data: {title: 'Request Certificate'}},
      {path: 'officelocations', component: OfficeLocationsComponent, data: {title: 'Office Locations'}},
      {path: 'officelocations/:id', component: OfficeLocationsComponent, data: {title: 'Office Locations'}},
      {path: 'district-office', component: DistrictOfficesComponent, data: {title: 'District Locator'}},
      {path: 'feedback', component: FeedbackComponent, data: {title: 'Feedback'}},
      {path: 'directory', component: DirectoryComponent, data: {title: 'Directory'}},
      {
        path: 'appointment', component: BookingsComponent, data: {title: 'Bookings'}
      },
      {
        path: 'appointment/:linkId', component: BookingsFormComponent, data: {title: 'Bookings'}
      },
      {
        path: 'district', component: BookingsDistrictComponent, data: {title: 'Bookings'}
      },
      {
        path: 'publicrecord',
        component: PublicRecordsComponent,
        data: {title: 'Public Record'}
      },
      {
        path: 'languageaccess',
        component: LanguageAccessServiceComponent,
        data: {title: 'Language Access Services'}
      },
      {
        path: 'languageaccess/:id',
        component: LanguageAccessServiceComponent,
        data: {title: 'Language Access Services'}
      },
      {
        path: 'websitesupport', component: WebsiteSupportComponent, data: {title: 'Website Support'}
      }

    ]
  },
  {
    path: 'homeowners',
    component: HomeownersComponent,
    children: [
      {
        path: 'property-search', component: PropertySearchComponent, data: {title: 'Property Search'}
      },
      {
        path: 'realproperty', component: RealpropertyComponent, data: {title: 'Real Property'}
      },

      {
        path: 'realproperty/:id', component: RealpropertyComponent, data: {title: 'Real Property'}
      },
      {
        path: 'realproperty/:id/:item', component: RealpropertyComponent, data: {title: 'Real Property'}
      },

      {
        path: 'change-mailing-address', component: ChangeaddressComponent, data: {title: 'Change Mailing Address'}
      },
      {
        path: 'change-mailing-address/:id', component: ChangeaddressComponent, data: {title: 'Change Mailing Address'}
      },
      {
        path: 'change-mailing-address/:id/:item', component: ChangeaddressComponent, data: {title: 'Change Mailing Address'}
      },
      {
        path: 'change-in-ownership', component: ChangeInOwnershipComponent, data: {title: 'Change in Ownership'}
      },
      {
        path: 'change-in-ownership/:id', component: ChangeInOwnershipComponent, data: {title: 'Change in Ownership'}
      },
      {
        path: 'new-construction', component: NewConstructionComponent, data: {title: 'New Construction'}
      },
      {
        path: 'new-construction/:id', component: NewConstructionComponent, data: {title: 'New Construction'}
      },
      {
        path: 'new-homeowners', component: NewhomeownersComponent, data: {title: 'New Homeowners'}
      },
      {
        path: 'new-homeowners/:id', component: NewhomeownersComponent, data: {title: 'New Homeowners'}
      },
      {
        path: 'homeowner-exemption', component: HomeownersexemptionComponent, data: {title: 'Homeowners Exemption'}
      },
      {
        path: 'homeowner-exemption/:id', component: HomeownersexemptionComponent, data: {title: 'Homeowners Exemption'}
      },
      {
        path: 'contest-assessment', component: ContestAssessedValueComponent, data: {title: 'Contesting Your Assessed Value'}
      },
      {
        path: 'contest-assessment/:id', component: ContestAssessedValueComponent, data: {title: 'Contesting Your Assessed Value'}
      },
      // {
      //   path: 'supplemental-tax-estimator', component: SupplementaltaxestimatorComponent, data: {title: 'Supplemental Tax Estimator'}
      // },
      // {
      //   path: 'supplemental-tax-estimator/:id', component: SupplementaltaxestimatorComponent, data: {title: 'Supplemental Tax Estimator'}
      // },
      // {
      //   path: 'transferring-assessed-value', component: TransferringassessedvalueComponent, data: {title: 'Transferring Your Assessed Value'}
      // },
      {
        path: 'adu', component: AduComponent, data: {title: 'ADU'}
      },
      {
        path: 'adu/:id', component: AduComponent, data: {title: 'ADU'}
      },
      {
        path: 'proposition-19', component: Prop19Component, data: {title: 'Homeowners - Proposition 19'}
      },
      {
        path: 'proposition-19/:id', component: Prop19Component, data: {title: 'Homeowners - Proposition 19'}
      },
      {
        path: 'proposition-19/:id/:item', component: Prop19Component, data: {title: 'Homeowners - Proposition 19'}
      },
      {
        path:'death-of-an-owner', component: DeathOfAnOwnerComponent, data: {title: 'Death of an Owner'}
      },
      {
        path:'death-of-an-owner/:id', component: DeathOfAnOwnerComponent, data: {title: 'Death of an Owner'}
      },
      {
        path: 'apply-for-hox',
        component: ApplyForHOXComponent,
        data: {title: 'Apply for Homeowners\' Exemption'}

      },
      {
        path: 'apply-for-hox/:id',
        component: ApplyForHOXComponent,
        data: {title: 'Apply for Homeowners\' Exemption'}
      }
    ]
  },
  {
    path: 'businessowners',
    component: BusinessownersComponent,
    children:[
      {
        path: 'marine-aircraft', component: MarineaircraftComponent, data: {title: 'Marine and Aircraft'}
      },
      {
        path: 'marine-aircraft/:id', component: MarineaircraftComponent, data: {title: 'Marine and Aircraft'}
      },
      {
        path: 'manufactured-homes', component: ManufacturedhomesComponent, data: {title: 'Manufactured Homes'}
      },
      {
        path: 'manufactured-homes/:id', component: ManufacturedhomesComponent, data: {title: 'Manufactured Homes'}
      },
      {
        path: 'business-prop-assessments', component: BusinesspropertystatementComponent, data: {title: 'Business Property Assessments'}
      },
      {
        path: 'business-prop-assessments/:id', component: BusinesspropertystatementComponent, data: {title: 'Business Property Assessments'}
      },
      {
        path: 'trends', component: TrendfactorsComponent, data: {title: 'Trend Factors'}
      },
      {
        path: 'important-dates', component: ImportantdatesComponent, data: {title: 'Important Dates'}
      },
      {
        path: 'important-dates/:id', component: ImportantdatesComponent, data: {title: 'Important Dates'}
      },
      {
        path: 'business-prop-statement-filing', component: BusinessStatementFilingComponent, data: {title: 'Business Statement Filing'}
      },
      {
        path: 'business-prop-statement-filing/:id', component: BusinessStatementFilingComponent, data: {title: 'Business Statement Filing'}
      }

    ]
  },
  {
    path: 'exclusions',
    component: ExclusionsComponent,
    children:[
      {
        path: 'solar', component: SolarComponent, data: {title: 'Solar and Seismic'}
      },
      {
        path: 'solar/:id', component: SolarComponent, data: {title: 'Solar and Seismic'}
      },
      {
        path: 'builders', component: BuildersComponent, data: {title: 'Builders'}
      },
      {
        path: 'builders/:id', component: BuildersComponent, data: {title: 'Builders'}
      },
      {
        path: 'registered-domestic-partners', component: RegisteredDomesticPartnersComponent, data: {title: 'Registered Domestic Partners'}
      },
      {
        path: 'registered-domestic-partners/:id', component: RegisteredDomesticPartnersComponent, data: {title: 'Registered Domestic Partners'}
      },
      {
        path: 'prop19', component: Prop19Component, data: {title: 'Exclusions - Proposition 19'}
      },
      {
        path: 'prop19/:id', component: Prop19Component, data: {title: 'Exclusions - Proposition 19'}
      },
      {
        path: 'inter-spousal', component: InterSpousalComponent, data: {title: 'Inter-Spousal'}
      },
      {
        path: 'inter-spousal/:id', component: InterSpousalComponent, data: {title: 'Inter-Spousal'}
      },
      {
        path: 'joint-tenancy', component: JointTenancyComponent, data: {title: 'Joint Tenancy'}
      },
      {
        path: 'joint-tenancy/:id', component: JointTenancyComponent, data: {title: 'Joint Tenancy'}
      }
    ]
  },
  {
    path: 'tax-relief',
    component: TaxreliefComponent,
    children:[
      {
        path: 'disaster-relief',
        component: DisasterreliefComponent,
        data: {title: 'Disaster Relief'}
      },
      {
        path: 'disaster-relief/:id',
        component: DisasterreliefComponent,
        data: {title: 'Disaster Relief'}
      },
      {
        path: 'disabled-transfer',
        component: DisabledComponent,
        data: {title: 'Disabled Persons'}
      },
      {
        path: 'disabled-transfer/:id',
        component: DisabledComponent,
        data: {title: 'Disabled Persons'}
      },
      {
        path: 'decline-in-value',
        component: DeclineinvalueComponent,
        data: {title: 'Decline in Value'}
      },
      {
        path: 'decline-in-value/:id',
        component: DeclineinvalueComponent,
        data: {title: 'Decline in Value'}
      },
      {
        path: 'prop19',
        component: Prop19Component,
        data: {title: 'Tax Relief - Proposition 19'}
      },
      {
        path: 'prop19/:id',
        component: Prop19Component,
        data: {title: 'Tax Relief - Proposition 19'}
      },
      {
         path: 'mills-act',
         component: MillsActComponent,
         data: {title: 'Mills Act'}
      },
      {
         path: 'mills-act/:id',
         component: MillsActComponent,
         data: {title: 'Mills Act'}
      },
      {
        path: 'change-in-ownership-rescission',
        component: ChangeOwnershipRescissionComponent,
        data: {title: 'Change in Ownership Rescission'}
      },
      {
        path: 'change-in-ownership-rescission/:id',
        component: ChangeOwnershipRescissionComponent,
        data: {title: 'Change in Ownership Rescission'}
      }
    ]
  },
  {
    path: 'exemptions',
    component: ExemptionsComponent,
    children:[
      {
        path: 'disabled-veterans',
        component: DisabledveteransComponent,
        data: {title: 'Disabled Veterans\'s Exemption'}
      },
      {
        path: 'disabled-veterans/:id',
        component: DisabledveteransComponent,
        data: {title: 'Disabled Veterans\'s Exemption'}
      },
      {
        path: 'church',
        component: ChurchComponent,
        data: {title: 'Churches and Religious'}
      },
      {
        path: 'church/:id',
        component: ChurchComponent,
        data: {title: 'Churches and Religious'}
      },
      // {
      //   path: 'religious',
      //   component: ReligiousComponent
      // },
      {
        path: 'non-profit',
        component:NonProfitComponent,
        data: {title: 'Non-Profits'}
      },
      {
        path: 'non-profit/:id',
        component:NonProfitComponent,
        data: {title: 'Non-Profits'}
      },
      // {
      //   path: 'welfare',
      //   component:WelfareComponent,
      //   data: {title: 'Welfare'}
      // },
      // {
      //   path: 'hospital-property',
      //   component:HospitalPropertyComponent,
      //   data: {title: 'Hospitals'}
      // },
      // {
      //   path: 'multispecialty-clinics',
      //   component:MultispecialtyClinicsComponent,
      //   data: {title: 'Clinics'}
      // },
      // {
      //   path: 'housing',
      //   component: HousingComponent,
      //   data: {title: 'Housing'}
      // },
      {
        path: 'veterans',
        component: VeteransComponent,
        data: {title: 'Veterans\'s Exemption'}
      },
      {
        path: 'veterans/:id',
        component: VeteransComponent,
        data: {title: 'Veterans\'s Exemption'}
      },
      {
        path: 'homeowner-exemption',
        component: HomeownersexemptionComponent,
        data: {title: 'Homeowners\' Exemption'}
      },
      {
        path: 'homeowner-exemption/:id',
        component: HomeownersexemptionComponent,
        data: {title: 'Homeowners\' Exemption'}
      }
    ]
  },
  {
    path: 'news-information',
    component: NewsInformationComponent,
    children:[
      {
        path: 'webinars-presentations',
        component: WebinarsPresentationsComponent,
        data: {title: 'Webinars & Presentations'}
      },
      {
        path: 'newsletters',
        component: NewslettersComponent,
        data: {title: 'Newsletters'}
      },
      {
        path: 'awards',
        component: AwardsComponent,
        data: {title: 'Awards'}
      },
      {
        path: 'awards/:id',
        component: AwardsComponent,
        data: {title: 'Awards'}
      },
      {
        path: 'assessmentroll',
        component: AssessmentRollComponent,
        data: {title: 'Assessment Roll'}
      },
      {
        path: 'annualroll',
        component: AnnualRollComponent,
        data: {title: 'Annual Report'}
      },
      {
        path: 'newsroom',
        component: NewsroomComponent,
        data: {title: 'Newsroom'}
      },
      {
        path: 'newsroom/:id',
        component: NewsroomComponent,
        data: {title: 'Newsroom'}
      },
      {
        path: 'events',
        component: EventsComponent,
        data: {title: 'Events'}
      },
      {
        path: 'events/:id',
        component: EventsComponent,
        data: {title: 'Events'}
      },
      {
        path: 'enotification',
        component: EnotificationComponent,
        data: {title: 'e-Notification'}
      },
      {
        path: 'enotification/:id',
        component: EnotificationComponent,
        data: {title: 'e-Notification'}
      },
      {
        path: 'careers', component: CareerOpportunitiesComponent, data: {title: 'Career Opportunities'}
      },
      {
        path: 'eservices-account-upgrades', component: EServicesAccountUpgradesComponent, data: {title: 'Assessor E-Services Account Upgrades'}
      }
      // {
      //   path: 'publicrecord',
      //   component: PublicRecordsComponent
      // }

    ]
  },
  {
    path: 'about-us',
    component: AboutUsComponent,
    children:[
      {
        path: 'property-tax-system',
        component: PropTaxSystemComponent,
        data: {title: 'Property Tax System'}
      },
      {
        path: 'property-tax-system/:id',
        component: PropTaxSystemComponent,
        data: {title: 'Property Tax System'}
      },
      {
        path: 'meet-the-assessor',
        component: MeetTheAssessorComponent,
        data: {title: 'Meet The Assessor'}
      },
      {
        path: 'meet-the-staff',
        component: MeetTheStaffComponent,
        data: {title: 'Meet the Staff'}
      }
    ]
  },
  {
    path: 'possessory-interest',
    component: PossessoryInterestComponent,
    data: {title: 'Possessory Interest'}
  },
  {
    path: 'possessory-interest/:id',
    component: PossessoryInterestComponent,
    data: {title: 'Possessory Interest'}
  },
  {
    path: 'data-sales', component: DataSalesComponent, data: {title: 'Data Sales'}
    // children:[
    //   {
    //     path:'gis-map',
    //     component: GISsalesComponent
    //   },
    //   {
    //     path:'general',
    //     component: DataSalesGeneralComponent
    //   },
    //   {
    //     path:'online-pdb',
    //     component: OnlinePDBComponent
    //   },
    //   {
    //     path:'price-list',
    //     component: PriceListComponent
    //   }
    // ]
  },
  {
    path: 'real-estate-toolkit',
    component: RealEstateToolkitComponent,
    children:[
      {
        path: 'welcome',
        component: WelcomeComponent,
        data: {title: 'Welcome'}
      },
      {
        path: 'proposition-19', component: Prop19Component, data: {title: 'Toolkit - Proposition 19'}
      },
      {
        path: 'proposition-19/:id', component: Prop19Component, data: {title: 'Toolkit - Proposition 19'}
      },
      {
        path: 'disaster-relief',
        component: DisasterreliefComponent,
        data: {title: 'Toolkit - Disaster Relief'}
      },
      {
        path: 'disaster-relief/:id',
        component: DisasterreliefComponent,
        data: {title: 'Toolkit - Disaster Relief'}
      },
      // {
      //   path: 'supplemental-tax-estimator',
      //   component: SupplementaltaxestimatorComponent,
      //   data: {title: 'Supplemental Tax Estimator'}
      // },
      {
        path: 'change-of-mailing-address',
        component: ChangeaddressComponent,
        data: {title: 'Toolkit - Change of Mailing Address'}
      },
      {
        path: 'change-of-mailing-address/:id',
        component: ChangeaddressComponent,
        data: {title: 'Toolkit - Change of Mailing Address'}
      },
      {
        path: 'new-construction',
        component: NewConstructionComponent,
        data: {title: 'New Construction'}
      },
      {
        path: 'new-construction/:id',
        component: NewConstructionComponent,
        data: {title: 'New Construction'}
      },
      {
        path: 'real-estate-fraud',
        component: RealEstateFraudComponent,
        data: {title: 'Real Estate Fraud'}
      },
      {
        path: 'real-estate-fraud/:id',
        component: RealEstateFraudComponent,
        data: {title: 'Real Estate Fraud'}
      },
      // {
      //   path: 'factors-prop-value',
      //   component: FactorsPropValueComponent
      // },
      {
        path: 'how-we-calculate-fmv',
        component: HowWeCalculateFMVComponent,
        data: {title: 'How we Calculate Fair Market Value'}
      },
      {
        path: 'how-we-calculate-fmv/:id',
        component: HowWeCalculateFMVComponent,
        data: {title: 'How we Calculate Fair Market Value'}
      },
      {
        path: 'proposition-13',
        component: Proposition13Component,
        data: {title: 'Proposition 13'}
      },
      {
        path: 'proposition-13/:id',
        component: Proposition13Component,
        data: {title: 'Proposition 13'}
      },
      {
        path: 'wills-and-trusts',
        component: WillsTrustsComponent,
        data: {title: 'Wills and Trusts'}
      },
      {
        path: 'wills-and-trusts/:id',
        component: WillsTrustsComponent,
        data: {title: 'Wills and Trusts'}
      },
      {
        path: 'apply-for-hox',
        component: ApplyForHOXComponent,
        data: {title: 'Apply for Homeowners\' Exemption'}

      },
      {
        path: 'apply-for-hox/:id',
        component: ApplyForHOXComponent,
        data: {title: 'Apply for Homeowners\' Exemption'}
      },
      {
        path: 'refinance',
        component: RefinanceComponent,
        data: {title: 'Refinancing'}
      },
      {
        path: 'refinance/:id',
        component: RefinanceComponent,
        data: {title: 'Refinancing'}
      },
      {
        path: 'when-do-i-get-reassessed',
        component: WhenDoIGetReassessedComponent,
        data: {title: 'Reassessed'}
      },
      {
        path: 'when-do-i-get-reassessed/:id',
        component: WhenDoIGetReassessedComponent,
        data: {title: 'Reassessed'}
      },
      {
        path: 'death-of-a-property-owner',
        component: DeathOfAnOwnerToolkitComponent,
        data: {title: 'Death of a Property Owner'}
      },
      {
        path: 'death-of-a-property-owner/:id',
        component: DeathOfAnOwnerToolkitComponent,
        data: {title: 'Death of a Property Owner'}
      },
      {
        path: 'events',
        component: EventsComponent,
        data: {title: 'Toolkit - Events'}
      },
      {
        path: 'events/:id',
        component: EventsComponent,
        data: {title: 'Toolkit - Events'}
      },
      {
        path: 'property-search',
        component: PropertySearchComponent,
        data: {title: 'Property Search Tool'}
      },
      {
        path: 'newsroom',
        component: NewsroomComponent,
        data: {title: 'Toolkit - Newsroom'}
      },
      {
        path: 'newsroom/:id',
        component: NewsroomComponent,
        data: {title: 'Toolkit - Newsroom'}
      },
      {
        path: 'data-sales', component: DataSalesComponent, data: {title: 'Toolkit - Data Sales'}
      },
      {
        path: 'data-sales/:id', component: DataSalesComponent, data: {title: 'Toolkit - Data Sales'}
      },
      {
        path: 'newsletters',
        component: NewslettersComponent,
        data: {title: 'Toolkit - Newsletters'}
      },
      {
        path: 'annualreport', component: AnnualRollComponent,data: {title: 'Toolkit - Annual Report'}
      },
      {
        path: 'new-homeowners', component: NewhomeownersComponent, data: {title: 'Toolkit - New Homeowners'}
      },
      {
        path: 'new-homeowners/:id', component: NewhomeownersComponent, data: {title: 'Toolkit - New Homeowners'}
      },
      {
        path: 'enotification', component: EnotificationComponent, data: {title: 'Toolkit - e-Notification'}
      },
      {
        path: 'enotification/:id', component: EnotificationComponent, data: {title: 'Toolkit - e-Notification'}
      }

    ]
  },
  {path: 'contact-us', redirectTo: '/contact/assessor', pathMatch: 'full'},
  {path: 'enotification', component: ENotificationRedirectComponent, pathMatch: 'full'},
  {path: 'appointment', redirectTo: '/contact/appointment', pathMatch: 'full'},
  {path: 'events', redirectTo: '/news-information/events', pathMatch: 'full'},
  {path: 'declineinvalue', redirectTo: '/tax-relief/decline-in-value', pathMatch: 'full'},
  {path: 'div', redirectTo: '/tax-relief/decline-in-value', pathMatch: 'full'},
  {path: 'prop19', redirectTo: '/homeowners/proposition-19', pathMatch: 'full'},
  {path: 'hox', redirectTo: '/exemptions/homeowner-exemption', pathMatch: 'full'},
  {path: 'disabledvets', redirectTo: '/exemptions/disabled-veterans', pathMatch: 'full'},
  {path: 'news', redirectTo: '/news-information/newsroom', pathMatch: 'full'},
  {path: 'vets', redirectTo: '/exemptions/veterans', pathMatch: 'full'},
  {path: 'newsletter', redirectTo: '/news-information/newsletters', pathMatch: 'full'},
  {path: 'newsletters', redirectTo: '/news-information/newsletters', pathMatch: 'full'},
  {path: 'disaster', redirectTo: '/tax-relief/disaster-relief', pathMatch: 'full'},
  {path: 'rescission', redirectTo: '/tax-relief/change-in-ownership-rescission', pathMatch: 'full'},
  {path: 'change-mailing-address', redirectTo: '/homeowners/change-mailing-address', pathMatch: 'full'},
  {path: 'reports', redirectTo: '/news-information/annualRoll', pathMatch: 'full'},
  {path: 'videos', redirectTo: '/news-information/webinars-presentations', pathMatch: 'full'},
  {path: 'adu', redirectTo: '/homeowners/adu', pathMatch: 'full'},
  {path: '571l', redirectTo: '/businessowners/business-prop-statement-filing', pathMatch: 'full'},
  {path: 'hox', redirectTo: '/homeowners/homeowner-exemption', pathMatch: 'full'},
  {path: 'error', component: ErrorComponent },
  {path: '**', component: HomeComponent}

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
